// Généré par maquettes/outils/dc2react.py à partir de la maquette. Ne pas modifier à la main :
// changer maquettes/src puis relancer le script.
import React from 'react';

export default function Methode({ v }) {
  return (
    <section id="methode" style={{ background: "#FFFFFF", borderTop: "1px solid #E3E5E8", borderBottom: "1px solid #E3E5E8" }}>
      <div className="m-sec" style={{ maxWidth: "1240px", margin: "0 auto", padding: "88px 24px", display: "flex", flexDirection: "column", gap: "28px" }}>
        <h2 style={{ margin: "0", fontSize: "clamp(32px, 3.4vw, 48px)", fontWeight: "800", fontStretch: "80%", lineHeight: "1.04" }}>
          Comment ça se passe
        </h2>
        <ol className="m-two" style={{ margin: "0", padding: "0", listStyle: "none", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(240px, 100%), 1fr))", gap: "1px", background: "#CDD1D6", border: "1px solid #CDD1D6" }}>
          <li style={{ padding: "22px", background: "#FFFFFF", display: "flex", flexDirection: "column", gap: "8px" }}>
            <span style={{ fontFamily: "'IBM Plex Mono', ui-monospace, monospace", fontSize: "13px", color: v.accent }}>
              01 · Gratuit
            </span>
            <p style={{ margin: "0", fontWeight: "800", fontSize: "20px", fontStretch: "85%" }}>
              Un appel de 30 min
            </p>
            <p style={{ margin: "0", fontSize: "15px", color: "#4A5059" }}>
              En visio. Je vous dis franchement si le sur-mesure vaut le coup.
            </p>
          </li>
          <li style={{ padding: "22px", background: "#FFFFFF", display: "flex", flexDirection: "column", gap: "8px" }}>
            <span style={{ fontFamily: "'IBM Plex Mono', ui-monospace, monospace", fontSize: "13px", color: v.accent }}>
              02 · Sous 3 jours
            </span>
            <p style={{ margin: "0", fontWeight: "800", fontSize: "20px", fontStretch: "85%" }}>
              Un prix fixe, par écrit
            </p>
            <p style={{ margin: "0", fontSize: "15px", color: "#4A5059" }}>
              Ce que fait l'outil, le délai, le prix. Vous payez 50 % au démarrage, et 50 % quand votre équipe a validé l'outil.
            </p>
          </li>
          <li style={{ padding: "22px", background: "#FFFFFF", display: "flex", flexDirection: "column", gap: "8px" }}>
            <span style={{ fontFamily: "'IBM Plex Mono', ui-monospace, monospace", fontSize: "13px", color: v.accent }}>
              03 · 3 semaines
            </span>
            <p style={{ margin: "0", fontWeight: "800", fontSize: "20px", fontStretch: "85%" }}>
              Un premier outil en ligne
            </p>
            <p style={{ margin: "0", fontSize: "15px", color: "#4A5059" }}>
              Sur vos vraies données, testé par votre équipe.
            </p>
          </li>
          <li style={{ padding: "22px", background: "#FFFFFF", display: "flex", flexDirection: "column", gap: "8px" }}>
            <span style={{ fontFamily: "'IBM Plex Mono', ui-monospace, monospace", fontSize: "13px", color: v.accent }}>
              04 · Pour de bon
            </span>
            <p style={{ margin: "0", fontWeight: "800", fontSize: "20px", fontStretch: "85%" }}>
              Un outil à vous
            </p>
            <p style={{ margin: "0", fontSize: "15px", color: "#4A5059" }}>
              Code, données et documentation vous appartiennent, et votre équipe sait s'en servir.
            </p>
          </li>
        </ol>
      </div>
    </section>
  );
}
